export const POST_UPLOAD = "/upload/"
export const POST_DELETE = "/delete/"
export const GET_WITHDRAW_REPORT = "/withdraw-report/"
export const GET_ADDED_MONEY_REPORT = "/added-money-report/"
export const GET_DEBIT_CATEGORY_REPORT = "/debit-category-report/"
export const GET_CREDIT_CATEGORY_REPORT = "/credit-category-report/"
export const GET_REPORT_SUMMARY = "/upload-report/"
export const GET_REFUND_MAPPING_REPORT = "/mapping-report/"
export const GET_OTHER_MAPPING_REPORT = "/other-mapping-report/"
export const POST_REGISTER = "/register/"
export const POST_LOGIN = "/login/"
